import MergeCompaniesMain from "@/components/MergeCompanies/mergeCompaniesMain.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import MergeCompaniesProvider from "@/services/MergeCompaniesContext/MergeCompaniesProvider";
import { Card, CardContent } from "@/shadcn/components/ui/card";
import React from "react";
import { useTranslation } from "react-i18next";

type PageMergeCompaniesProps = {
  // TODO: add props here
};

const PageMergeCompanies: React.FC<PageMergeCompaniesProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BasePage currPage="mergeCompanies">
      <div className="h-full overflow-y-auto">
        <Card className="lg:m-4">
          <CardContent>
            <h1 className="text-center text-3xl font-bold">
              {t("Merge Companies")}
            </h1>
            <MergeCompaniesProvider>
              <MergeCompaniesMain />
            </MergeCompaniesProvider>
          </CardContent>
        </Card>
      </div>
    </BasePage>
  );
};

export default PageMergeCompanies;
